import React, { ReactElement } from 'react';

import { HEX } from './colour-types';

export const DiagonalHatchDefinition = (props: { id: string; stroke?: HEX }): ReactElement => {
	return (
		<pattern id={props.id} patternUnits="userSpaceOnUse" width="10" height="10">
			<path
				d="M-5,5 l10,-10 M0,10 l10,-10 M5,15 l10,-10"
				style={{ stroke: props.stroke ?? '#555', strokeWidth: 1 }}
			/>
		</pattern>
	);
};
